// =============================================
//  KLAVIYO: Add To Cart Tracking (universal)
// =============================================

(function () {
  const _learnq = window._learnq || [];
  let sent = false;

  // ----- Utils -----
  function sendEvent(cart) {
    if (sent) return;
    sent = true;

    _learnq.push(['track', 'Added to Cart', cart]);

    // allow next event after short cooldown (spam protection)
    setTimeout(() => (sent = false), 300);
  }

  function fetchCartAndSend() {
    fetch('/cart.js')
      .then((res) => res.json())
      .then((data) => {
        const cart = {
          $value: data.total_price / 100,
          total_price: data.total_price / 100,
          original_total_price: data.original_total_price / 100,
          total_discount: data.total_discount,
          items: data.items,
        };

        sendEvent(cart);
      })
      .catch(() => {});
  }

  // =============================================
  // 1) Interception fetch()
  // =============================================

  const originalFetch = window.fetch;
  window.fetch = function () {
    return originalFetch.apply(this, arguments).then((res) => {
      try {
        if (res.url.includes('/cart/add') || res.url.includes('/cart/change')) {
          fetchCartAndSend();
        }
      } catch {}
      return res;
    });
  };

  // =============================================
  // 2) Interception XMLHttpRequest (Old AJAX)
  // =============================================

  const originalXHR = window.XMLHttpRequest;
  function interceptXHR() {
    const xhr = new originalXHR();

    xhr.addEventListener('load', function () {
      try {
        if (this.responseURL.includes('/cart/add') || this.responseURL.includes('/cart/change')) {
          fetchCartAndSend();
        }
      } catch {}
    });

    return xhr;
  }
  window.XMLHttpRequest = interceptXHR;

  // =============================================
  // 3) Form submit fallback (Not AJAX)
  // =============================================

  document.addEventListener('click', (e) => {
    const btn = e.target.closest("form[action*='/cart/add'] button[type='submit']");
    if (!btn) return;

    setTimeout(fetchCartAndSend, 500);
  });
})();